import { render, staticRenderFns } from "./sales_pricing_faqs.vue?vue&type=template&id=87e4d0a0&"
import script from "./sales_pricing_faqs.vue?vue&type=script&lang=js&"
export * from "./sales_pricing_faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports